// dbServer#114: account identity key for the multi-account (cur_accounts) cookie
// store.
//
// Two sandboxes of the same production org can return the same
// {orgId}.{userId}: the sandbox OAuth response yields the parent production org
// id, and sandbox user ids mirror production. With a two-segment key both
// sandbox accounts collided on one key, so logging into the second sandbox
// overwrote (evicted) the first. The Salesforce instance / My Domain host
// (baseUrl) is always distinct per sandbox, so folding a cookie-name-safe form
// of it into the key makes each sandbox a distinct account. Production accounts
// get the same suffix harmlessly (their org ids already differ).
//
// The result is used as a cookie NAME, so the host segment is stripped of the
// scheme and reduced to cookie-safe characters ([A-Za-z0-9._-]).
export function buildAccountKey(orgId, userId, baseUrl) {
  var base = orgId + "." + userId;
  var host = (baseUrl || "")
    .replace(/^https?:\/\//, "")
    .replace(/[^A-Za-z0-9._-]/g, "");
  return host ? base + "." + host : base;
}
